<template lang="pug">
  v-dialog(v-model="activo", :max-width="ancho", :persistent="persistent ? persistent : false")
    template(v-if="toolbar")
      v-toolbar(dense, flat, :color="color", :dark="dark", :light="!dark")
        template(v-if="icon")
          v-icon(:class="dark ? 'white--text' : ''") {{icon}}
        template(v-if="titulo")
          v-toolbar-title {{titulo}}
    v-card
      v-card-text
        slot
      v-card-actions(v-if="persistent || actions")
        v-spacer
        v-btn(color="red", small, depressed, dark, @click="cerrar") cerrar
        v-btn(color="secondary", small, depressed, @click="aceptando", :loading="loading") {{aceptar || 'aceptar'}}
</template>

<script>
export default {
  //  persistent: boolean 
  //  aceptar: string = texto boton aceptar 
  //  actions: boolean = mostar/ocultar botones
  //  toolbar: boolean = mostrar/ocultar toolbar
  //  color: string = color del toolbar
  //  icon: string = icono de toolbar
  //  dark: boolean = toolbar oscura
  //  titulo: string = titulo de toolbar 
  // loading: boolean
  props:['persistent', 'aceptar', 'actions', 'color', 'dark', 'icon', 'titulo', 'toolbar', 'loading'],
  data () {
    return {
      activo: false,
      ancho: '320px'
    }
  },
  methods: {
    cerrar () {
      this.$emit('cerrando')
      this.activo = false
    },
    aceptando () {
      this.$emit('aceptando')
      // this.activo = false
    }
  }
}
</script>

<style>

</style>
